import { InjectionToken } from '@angular/core';

export const SETTINGS_API_URL = new InjectionToken<string>('SETTINGS_API_URL');

/** Normaliza el origen público y asegura el prefijo `/api/settings`. */
export function resolveSettingsApiUrl(configuredUrl: string): string {
  const normalized = configuredUrl.replace(/\/+$/, '');
  return normalized.endsWith('/api/settings')
    ? normalized
    : `${normalized}/api/settings`;
}
